export default {
  companyUrl: 'https://www.lwtears.com',
  digitalAssetsUrl: 'https://a-z-educator-content.lwtears.com',
};
